<template>
  <div class="modal-wrap modal-wrap--35">
    <div class="modal-header">
      <p class="mb-15 bold">Skicka beskrivning</p>
    </div>

    <div class="modal-content">
      <p class="mb-15">Vill du skicka ett SMS till {{ currentCustomer.fullName }} med en länk till objektets internetannons?</p>
    </div>
    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="this.$root.abortForm">
          avbryt
        </button>
        <button class="width-100" @click="send">
          skicka
        </button>
      </div>
    </div>
    <spinner v-show="loading"/>
  </div>
</template>

<script>
import spinner from '../../spinner';
import Bugsnag from '@bugsnag/js';

export default {
  name: 'sendDescription',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    currentCustomer() {
      return this.$store.state.showing.currentData;
    }
  },
  methods: {
    send() {
      this.loading = true;
      let data = {
        customerId: this.$store.state.showing.currentData.customerId,
        activityShowingId: this.$store.state.showing.currentData.activityShowingId,
        objectId: this.$route.params.id,
      };

      this.$root.callFasAdApi('/internalapi/showing/send-description-sms', 'POST', data).then((data) => {
        this.loading = false;
        this.$root.modalOpen = false;
        this.$store.dispatch('showing/storeShowingDataForSelectedListing', {listingId: this.$route.params.id});
        this.$root.handleResponseMessage(data, 'Objektbeskrivningen skickades korrekt.');
      }).catch((error) => {
            Bugsnag.notify(error);
            Bugsnag.notify(data.customerId);
            Bugsnag.notify(data.activityShowingId);
          });
    },
  },
  components: {
    spinner
  }
}
</script>
